'use strict';

const init = () => {
    const header = document.getElementById('main-header')
    const photoswipe = document.querySelector('.pswp')

    document.querySelectorAll('.lightbox-images').forEach((galleryImage) => {
        galleryImage.addEventListener('click', () => {
            setTimeout(() => {
                const header = document.getElementById('main-header')
                header.style.transition = 'transform .3s ease-in-out'
                header.style.transform = 'translate(0px, -101px)'

                if (photoswipe) {
                    const observer = new MutationObserver((mutationsList) => {
                        mutationsList.forEach((mutation) => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                if (!photoswipe.classList.contains('pswp--open')) {
                                    header.style.transform = 'translate(0px, 0px)'
                                    setTimeout(() => {
                                        header.style.transition = 'none'
                                    }, 300)
                                    observer.disconnect()
                                }
                            }
                        })
                    })
                    observer.observe(photoswipe, {attributes: true})
                }
            }, 10)
        })
    })

    const mediaQuery = window.matchMedia("(orientation: portrait)");

    mediaQuery.addEventListener("change", (event) => {
        if (photoswipe.classList.contains('pswp--open')) {
            header.style.transition = 'transform .3s ease-in-out'
            header.style.transform = 'translate(0px, -101px)'
        }
    });
}

export default {init}
